import { jsx as _jsx } from "react/jsx-runtime";

function SvgInstagramSingle() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      d: "M12 2.983c2.937 0 3.285.01 4.446.064 2.98.136 4.373 1.55 4.509 4.509.053 1.16.063 1.508.063 4.445 0 2.938-.01 3.285-.063 4.445-.137 2.956-1.525 4.373-4.51 4.509-1.16.053-1.506.064-4.445.064-2.937 0-3.285-.01-4.445-.064-2.988-.137-4.373-1.557-4.509-4.51-.053-1.16-.064-1.507-.064-4.445 0-2.937.012-3.284.064-4.445.137-2.958 1.525-4.373 4.51-4.509 1.16-.052 1.507-.063 4.444-.063zM12 1c-2.987 0-3.361.013-4.535.066-3.995.183-6.215 2.4-6.398 6.398C1.013 8.64 1 9.013 1 12c0 2.987.013 3.362.066 4.536.183 3.994 2.4 6.215 6.398 6.398C8.64 22.987 9.013 23 12 23c2.987 0 3.362-.013 4.536-.066 3.99-.183 6.216-2.4 6.397-6.398.054-1.174.067-1.549.067-4.536 0-2.987-.013-3.361-.066-4.535-.18-3.99-2.399-6.215-6.397-6.398C15.362 1.013 14.987 1 12 1zm0 5.351a5.649 5.649 0 100 11.298A5.649 5.649 0 0012 6.35zm0 9.316a3.666 3.666 0 110-7.333 3.666 3.666 0 010 7.333zm5.872-10.858a1.32 1.32 0 100 2.64 1.32 1.32 0 000-2.64z",
      fill: "currentColor"
    }, void 0)
  }), void 0);
}

export default SvgInstagramSingle;